"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CALL_OPTION = void 0;
const context_1 = require("@derivation-tech/context");
exports.DEFAULT_CALL_OPTION = {
    waitReceipt: true,
    waitTimeout: 3 * 60,
    estimateGas: true,
    gasLimitMultiple: 1.5,
    gasPriceMultiple: 1.2,
    loggerOps: {
        level: context_1.LogLevel.Info,
    },
};
